module.exports = __webpack_public_path__ + "static/media/ic_trending.9da1565b.svg";